import { useCallback, useSyncExternalStore } from "react";
export function useMediaQuery(query) {
  var defaultSSRValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var subscribe = useCallback(function (callback) {
    var matchMedia = window.matchMedia(query);
    matchMedia.addEventListener("change", callback);
    return function () {
      matchMedia.removeEventListener("change", callback);
    };
  }, [query]);
  var getSnapshot = function getSnapshot() {
    return window.matchMedia(query).matches;
  };
  var getServerSnapshot = function getServerSnapshot() {
    return defaultSSRValue;
  };
  var matches = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return matches;
}